import React, { Component } from "react";

import Modal from 'react-bootstrap/Modal';
import { Button } from "react-bootstrap";
export class NotificationModal extends Component {
  constructor(props) {
    super(props);  
    this.state={
        show: false,
        closeButton: this.props.closeButton ?? true,
    }
  }

  handleAcceptConfirmation = () => {
    this.props.handleModal()   
  }

  render(){
    return(
      <>      
      <Modal
        show={this.props.show}
        onHide={this.props.handleModal}
        backdrop="static"
        keyboard={false}
        className={`custom-column-modal-container ${this.props.customClass}`}
      >
        <Modal.Header closeButton={this.state.closeButton}>
          <Modal.Title>{this.props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>  
            <div className="message-body">
               {this.props.message}
            </div>      
                    
            {
                this.props.subMessage &&
                <div className="sub-message-body">                     
                    {this.props.subMessage}
                </div>
            }
        </Modal.Body>
        <Modal.Footer>
            <Button variant="primary" onClick={this.handleAcceptConfirmation}>OK</Button>                   
        </Modal.Footer>
      </Modal>

      </>
    );
  }
}
